"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var Buffer_1 = require("./Buffer");

var Hint_1 = require("./Hint");

var shape = prop_types_1.default.shape({
  buffer: Buffer_1.Buffer.shape.isRequired,
  hints: prop_types_1.default.arrayOf(Hint_1.Hint.shape).isRequired,
  showHints: prop_types_1.default.bool.isRequired
});

function createEmpty() {
  return {
    buffer: Buffer_1.Buffer.create(''),
    hints: [],
    showHints: false
  };
}

function createFromText(text) {
  return {
    buffer: Buffer_1.Buffer.create(text),
    hints: [],
    showHints: false
  };
}

function getText(editorState) {
  return editorState.buffer.lines.join('\n');
}

var defaultValue = createEmpty();
exports.EditorState = {
  createEmpty: createEmpty,
  createFromText: createFromText,
  default: defaultValue,
  getText: getText,
  shape: shape
};